import script from "./ViewTalksForAEmployee.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewTalksForAEmployee.vue?vue&type=script&setup=true&lang=js"

import "./ViewTalksForAEmployee.vue?vue&type=style&index=0&id=52fc4428&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52fc4428"]])

export default __exports__